export default {"src":"/_next/static/media/counter-minus.da152453.svg","height":1,"width":9,"blurWidth":0,"blurHeight":0};